/**
 * Copyright (c) 2026, CheckPlus Limited
 */
import React, { Component } from "react";
import "./SignupPassword.css";
import { Link } from "react-router-dom";
import PropTypes from "prop-types";
import { validPw } from "../../assets/validators/donorInfo.js";
import { Helmet } from "react-helmet";

class SignupPassword extends Component {
  constructor(props) {
    super(props);
    if (this.props.location.state === undefined) {
      if (this.props.history.length <= 1) {
        this.props.history.push("/");
        return;
      } else {
        this.props.history.push("/LoginEmail");
        return;
      }
    }

    this.state = {
      username: this.props.location.state.username,
      password: "",
      errMsgs: [],
    };

    this.handleChange = this.handleChange.bind(this);
    this.reroute = this.reroute.bind(this);
  }

  handleChange(event) {
    this.setState({
      ...this.state,
      ...{
        password: event.target.value,
      },
    });
  }

  reroute() {
    const validData = validPw(this.state.password, this.props.language);

    if (!validData.isValid) {
      this.setState({
        errMsgs: validData.msgs,
      });
      return false;
    }

    this.props.history.push({
      pathname: "/SignupPasswordAgain",
      state: {
        username: this.state.username,
        password: this.state.password,
        color: this.props.location.state.color,
        logoStyle: this.props.location.state.logoStyle,
        organizationName: this.props.location.state.organizationName,
      },
    });
  }

  render() {
    // The constructor already redirects away when location.state is missing
    // (direct visit / refresh wipes it). Bail out of this transitional render
    // so we don't dereference undefined state before that navigation lands.
    if (!this.props.location.state || !this.props.location.state.color) {
      return null;
    }

    const logoStyle = this.props.location.state.logoStyle;

    const languageObj = this.props.languageObj;

    //    const color = this.props.location.state.color;

    const backgroundOverrideStyle = {
      background: "#" + this.props.location.state.color.headerColor,
    };

    const textOverrideStyle = {
      color: "#" + this.props.location.state.color.buttonColor,
    };
    /*
    const buttonOverrideStyle = {
      background: '#' + this.props.location.state.color.headerColor,
      color: '#' + this.props.location.state.color.buttonColor
    };
*/

    const organizationName = this.props.location.state.organizationName;

    const handleKeyDown = (event) => {
      if (event.key === "Enter") {
        this.reroute();
      }
    };

    return (
      <div className="SignupPassword-view">
        <Helmet>
          <title>{organizationName}</title>
        </Helmet>
        <div className="SignupPassword-prompt">
          <Link to={"/LoginPrompt"}>
            <div className="SignupPassword-backContainer">
              <div className="SignupPassword-back">
                <div className="SignupPassword-backBtn"></div>
                <div className="SignupPassword-backText">
                  {languageObj.backBtn}
                </div>
              </div>
            </div>
          </Link>

          <div
            className="SignupPassword-logoContainer"
            style={backgroundOverrideStyle}
          >
            {logoStyle && (
              <div className="SignupPassword-logo" style={logoStyle}></div>
            )}
          </div>

          <div className="SignupPassword-text">{languageObj.text}</div>

          <div className="SignupPassword-note">{languageObj.note}</div>

          <div className="SignupPassword-inputFieldContainer">
            <div className="SignupPassword-inputContainerLeft">
              <input
                onChange={this.handleChange}
                type="password"
                className="SignupPassword-inputField"
                placeholder={languageObj.placeholder}
                onKeyDown={handleKeyDown}
              />
            </div>
            <div className="SignupPassword-inputContainerRight">
              <div
                onClick={this.reroute}
                className="SignupPassword-nextBtn"
                style={backgroundOverrideStyle}
              >
                <div
                  className="SignupPassword-nextText"
                  style={textOverrideStyle}
                >
                  {languageObj.nextBtn}
                </div>
              </div>
            </div>
          </div>

          {this.state.errMsgs.map((err) => (
            <div key={err} className="SignupPassword-errorContainer">
              <div className="SignupPassword-errorIndicator"></div>
              <div className="SignupPassword-errorMessage">{err}</div>
            </div>
          ))}

          <div className="SignupPassword-chin"></div>
        </div>
      </div>
    );
  }
}

SignupPassword.propTypes = {
  language: PropTypes.string,
  languageObj: PropTypes.object,
};

export default SignupPassword;
